import { AppForm } from '../../../../../../common/forms/app.form';
import { FormControl, Validators } from '@angular/forms';
import { ApplicationAppEntityApplicationRead, ApplicationAppEntityApplicationWrite } from '../../../../../../openapi';
import { toNumber } from '../../../../../../services/helpers';
import { Injectable } from '@angular/core';
import { CustomValidator } from '../../../../../../common/forms/custom.validators';

@Injectable()
export class BaseInfoForm extends AppForm {
  public get yearList(): number[] {
    const result: number[] = [];
    for (let i = new Date().getFullYear() - 6; i <= new Date().getFullYear(); i++) {
      result.push(i);
    }
    return result.reverse();
  }

  constructor() {
    super({
      validityYear: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      validityMonth: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      submissionPurpose: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      submissionPurposeAdditionalInfo: new FormControl('', [Validators.maxLength(255)]),
      entityKind: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      })
    });
  }

  public get entityKind(): FormControl {
    return this.get('entityKind') as FormControl;
  }

  public get submissionPurpose(): FormControl {
    return this.get('submissionPurpose') as FormControl;
  }

  public submissionPurposeChange(v: string): void {
    if (v === 'Zmiana miejsca zamieszkania lub siedziby') {
      this.addControl(
        'residenceChangeDate',
        new FormControl(null,
          {
            validators: [
              Validators.required,
              CustomValidator.isValidDateFormat(),
              CustomValidator.maxDate(new Date())
            ]
          }
        )
      );
      this.addControl('previousTaxOfficeNameAndAddress', new FormControl(null, [Validators.required, Validators.maxLength(255)]));
    } else {
      this.removeControl('residenceChangeDate');
      this.removeControl('previousTaxOfficeNameAndAddress');
    }
  }

  public get residenceChangeDate(): FormControl | null {
    return this.get('residenceChangeDate') as FormControl | null;
  }

  public get previousTaxOfficeNameAndAddress(): FormControl | null {
    return this.get('previousTaxOfficeNameAndAddress') as FormControl;
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead | null): void {
    this.submissionPurposeChange(value?.submissionPurpose || '');
    super.patchFormValues(value);
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    return {
      ...this.value,
      validityYear: toNumber(this.value.validityYear),
      residenceChangeDate: this.residenceChangeDate?.value || null,
      previousTaxOfficeNameAndAddress: this.previousTaxOfficeNameAndAddress?.value || null
    };
  }
}
